// VendorQuotationPage.tsx
import React, { useEffect, useState } from 'react';
import { Product, SegmentType } from '../../types/ProductsForm';
import AddProduct from '../product/AddProduct';
import QuotationList from './QuotationList';
import { apiRequest } from '../../utils/apiClient';
import { QuoteData } from '../../types/Interface';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Carousel } from 'react-responsive-carousel';
import ZoomableImage from './ZoomableImage';


const defaultProduct: Product = {
  productCode: "",
  productName: "",
  segment: SegmentType.DIAMOND_JEWELLERY,
  category: "Rings",
  subCategory: [],
  image: [],
  price: 0,
  tags: [],
  occasion: "",
  vendor: "aurum",
  certification: "IGI",
  gender: "unisex",
  productSummary: {
    width: "",
    grossWt: "",
  },
  priceBreakup: {
    metal: 0,
    discountedDiamondPrice: 0,
    actualDiamondPrice: 0,
    discountMakingCharges: 0,
    makingCharges: 0,
    gst: 0,
    gstPercent: 0,
    total: 0,
    discountTotal: 0,
  },
  discountPercent: "",
  metalDetails: {
    metalName: "yellow gold",
    purity: 18,
    metalWt: 0.0,
  },
  diamondDetails: {
    totalNumberOfDiamonds: 0,
    totalWt: 0.0,
    diamonds: {
      clarity: "VVS",
      color: "EF",
      numberOfDiamonds: 0,
      settingType: "Solitaire",
      shape: "Round",
      diamondWtApprox: 0.0,
      additionalCharges: 0.0
    },
    diamondEntries: [],
    solitaireEntries: [],
    solitaire: {
        stClarity: "VVS",
        stColor: "EF",
        numberOfStDiamonds: 0,
        stSettingType: "Solitaire",
        stShape: "Round",
        stDiamondWt: 0.0,
        availableSizes: []
    },
  },
  productDescription: "",
  makingPercentage: 0,
  note: "",
  isCatalog: false,
  isInventory: false
};

const VendorQuotationPage = () => {
  const [selectedQuoteData, setSelectedQuoteData] = useState<QuoteData>();
  const [quotations, setQuotations ] = useState<QuoteData[]>([]);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  // const [selectedProduct, setSelectedProduct] = useState<Product>(defaultProduct);

  useEffect(() => {
    if (selectedQuoteData && selectedQuoteData.product?.productCode.startsWith("CUSTOM_ORDER_QUOTE")) {
        console.log(selectedQuoteData)
      setEditDialogOpen(true);
    }
  }, [selectedQuoteData]);


  useEffect(() => {
    async function fetchQuotes() {
      try {
        const res = await apiRequest(`/api/quote`);
        console.log(res);
        setQuotations(res);
      } catch (err) {
        console.error('Failed to fetch quotations', err);
      }
    }

    fetchQuotes();
  }, []);

  const handleSelectQuotation = (data: QuoteData) => { 
    const mergedProduct: Product = {
        ...structuredClone(defaultProduct),
        productCode: `CUSTOM_ORDER_QUOTE_${data.id}`,
        productName: `CUSTOM_ORDER_QUOTE_${data.id}`,
        
        segment: data.product?.segment ?? defaultProduct.segment,
        category: data.product?.category ?? defaultProduct.category,
        subCategory: data.product?.subCategory ?? defaultProduct.subCategory,
        image: data.product?.image ?? defaultProduct.image,
        price: data.product?.price ?? defaultProduct.price,
        tags: data.product?.tags ?? defaultProduct.tags,
        occasion: data.product?.occasion ?? defaultProduct.occasion,
        vendor: data.product?.vendor ?? defaultProduct.vendor,
        certification: data.product?.certification ?? defaultProduct.certification,
        gender: data.product?.gender ?? defaultProduct.gender,
        
        productSummary: {
          ...defaultProduct.productSummary,
          ...data.product?.productSummary,
        },
      
        priceBreakup: {
          ...defaultProduct.priceBreakup,
          ...data.product?.priceBreakup,
        },
      
        discountPercent: data.product?.discountPercent ?? defaultProduct.discountPercent,
      
        metalDetails: {
          ...defaultProduct.metalDetails,
          ...data.product?.metalDetails,
        },
      
        diamondDetails: {
          ...defaultProduct.diamondDetails,
          ...data.product?.diamondDetails,
          diamonds: {
            ...defaultProduct.diamondDetails.diamonds,
            ...data.product?.diamondDetails?.diamonds,
          },
          solitaire: {
            ...defaultProduct.diamondDetails.solitaire,
            ...data.product?.diamondDetails?.solitaire,
          },
          diamondEntries: data.product?.diamondDetails?.diamondEntries ?? defaultProduct.diamondDetails.diamondEntries,
          solitaireEntries: data.product?.diamondDetails?.solitaireEntries ?? defaultProduct.diamondDetails.solitaireEntries,
        },
      
        productDescription: data.product?.productDescription ?? defaultProduct.productDescription,
        note: data.product?.note ?? defaultProduct.note,
      };

      const updatedQuoteData: QuoteData = {
        ...data,
        product: mergedProduct,
      };

      setSelectedQuoteData(updatedQuoteData);
      
  
    // setSelectedProduct(mergedProduct);
  };

      


  return (
    <div className="p-3 md:p-4 space-y-6">
         <div className="grid grid-cols-1 xl:grid-cols-5 gap-6">
    {/* Pending Quotations - 60% width */}
    <div className="xl:col-span-3">
      <h2 className="text-xl font-semibold mb-2">Pending Quotations</h2>
      <QuotationList
        quotations={quotations.filter(q => !q.finalQuote)}
        onSelectQuotation={handleSelectQuotation}
      />
      
    </div>

    {/* Finalized Quotations - 40% width */}
    <div className="xl:col-span-2 xl:border-l xl:pl-4">
      <h2 className="text-xl font-semibold mb-2">Finalized Quotations</h2>
      {quotations.filter(q => q.finalQuote).length === 0 ? (
        <p className="text-gray-500">No finalized quotations yet.</p>
      ) : (
        <div className="space-y-4">
        {quotations.filter(q => q.finalQuote).map((q) => (
            <div key={q.id} className="border rounded-lg p-4 shadow-sm bg-white">
            <div className="flex flex-col sm:flex-row gap-4">
                {/* Left Section: Image Carousel or Product Link */}
              <div className="w-full sm:w-32 h-32 flex-shrink-0 flex items-center justify-center">
                {q.images && q.images.length > 0 ? (
                    <Carousel showThumbs={false} showStatus={false} infiniteLoop>
                    {q.images.map((image, i) => (
                        <div key={i} className="w-full h-full">
                        <img
                            src={image}
                            alt={`Image ${i + 1}`}
                            className="object-cover w-full h-full rounded"
                        />
                        </div>
                    ))}
                    </Carousel>
                ) : q.link ? (
                    <a
                    href={q.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-700 underline text-sm"
                    >
                    Product Link
                    </a>
                ) : null}
                </div>

                {/* Right Section: Quote Details */}
                <div className="flex flex-col justify-between">
                <p><strong>Quote ID:</strong> {q.id}</p>
                <p><strong>Total Price:</strong> ₹{q.product?.price?.toLocaleString() ?? 'N/A'}</p>
                <p><strong>Mobile:</strong> {q.user?.mobile ?? 'N/A'}</p>
                <p><strong>Email:</strong> {q.user?.email ?? 'N/A'}</p>
                </div>
            </div>
            </div>
        ))}
        </div>


      )}
    </div>
  </div>
      
          {/* Edit Dialog */}
          <Dialog
            open={editDialogOpen}
            onClose={() => setEditDialogOpen(false)}
            maxWidth="lg"
            fullWidth
          >
            <DialogTitle>Update Quote</DialogTitle>
            <DialogContent dividers>
              {selectedQuoteData && (
                <AddProduct
                  // updateproduct={selectedProduct}
                //   onChange={handleChange}
                  quoteData = {selectedQuoteData}
                  isEditMode={true}
                  isAddMode={true}
                  openDialog={setEditDialogOpen}
                />
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setEditDialogOpen(false)}>Cancel</Button>
              {/* <Button variant="contained" onClick={handleSaveQuote}>Save</Button> */}
            </DialogActions>
          </Dialog>
    </div>    
  );
};

export default VendorQuotationPage;
